
import { Button } from "@/components/ui/button";
import { UserCheck, UserX } from "lucide-react";
import { cn } from "@/lib/utils";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

interface UserRoleToggleProps {
  userId: string;
  isAdmin: boolean;
  onUpdate: () => Promise<void>;
}

export default function UserRoleToggle({ userId, isAdmin, onUpdate }: UserRoleToggleProps) {
  const toggleAdminRole = async () => {
    try {
      const { data, error } = await supabase.rpc('toggle_admin_role', {
        target_user_id: userId,
        make_admin: !isAdmin
      });
      
      if (error) throw error;
      
      toast.success(isAdmin ? "Admin role removed successfully" : "Admin role added successfully");
      onUpdate();
    } catch (error: any) {
      console.error("Error toggling admin role:", error);
      toast.error(error.message || "Failed to update user role");
    }
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleAdminRole}
      className={cn(
        "gap-1 text-xs",
        isAdmin ? "text-destructive hover:text-destructive/90" : "text-primary hover:text-primary/90"
      )}
    >
      {isAdmin ? (
        <>
          <UserX className="h-3.5 w-3.5" />
          Remove Admin
        </>
      ) : (
        <>
          <UserCheck className="h-3.5 w-3.5" />
          Make Admin
        </>
      )}
    </Button>
  );
}
